import { DateRange } from 'bold-ui'
import { CiapCidSelectModel } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import { GrupoCondicaoSelectModel } from 'components/form/field/select/GrupoCondicaoSelectField'
import {
  OpcaoSelecionadaRelatorioGerencialEnum,
  TipoAgrupamentoRelatorioGerencialEnum,
  UnidadePeriodoRelatorioGerencialEnum,
} from 'graphql/types.generated'

import { ModeloPersonalizadoModel } from '../modelo-personalizado/model-modeloPersonalizado'

export interface RelatorioGerencialFiltrosFormModel {
  unidade?: UnidadePeriodoRelatorioGerencialEnum
  opcaoSelecionada?: OpcaoSelecionadaRelatorioGerencialEnum
  periodo?: DateRange
  ciapsCids: CiapCidSelectModel[]
  gruposCondicoesPrioritarios: ReadonlyArray<GrupoCondicaoSelectModel>
  modeloPersonalizado?: ModeloPersonalizadoModel
  tipoAgrupamento?: TipoAgrupamentoRelatorioGerencialEnum
}

export const RELATORIO_GERENCIAL_FILTROS_FORM_DEFAULT_VALUES: RelatorioGerencialFiltrosFormModel = {
  opcaoSelecionada: OpcaoSelecionadaRelatorioGerencialEnum.PRIMEIRA,
  unidade: UnidadePeriodoRelatorioGerencialEnum.MES,
  ciapsCids: [],
  gruposCondicoesPrioritarios: [],
  // TODO (eldorado #31367) remover daqui se ficar muito específico do relatório de cadastro
  tipoAgrupamento: TipoAgrupamentoRelatorioGerencialEnum.PESSOAS,
}
